import React from "react";
import {LocalStorage} from "../components/LocalStorage";
import {XHR} from "../components/XHR";
import {StatusPage} from "./StatusPage";

export class LogoutAction extends React.Component<any, any> {
    private storage: LocalStorage = new LocalStorage();
    private request: XHR = new XHR();

    render() {

        this.request.fetch('/logout', null, {
            method: 'GET'
        }).then(e => {
            this.storage.clear();
            window.location.assign('/');
        });

        return <StatusPage code="Logout" message="in progress.."/>;
    }
}
